<template>
  <v-card flat class="mt-4">
    <v-row>
      <v-col cols="4" class="pa-0 align-right">
        <v-list-item dense>
          <v-list-item-icon class="mr-2">
            <v-icon color="neutralGray">mdi-calendar-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("lblSchedule") }}:</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="8" class="contentValue">
        {{ getTimeDetails(data) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pa-0 align-right">
        <v-list-item dense>
          <v-list-item-icon class="mr-2">
            <v-icon color="neutralGray">mdi-map-marker-radius</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >{{ $t("agenda.lblMeetingLocation") }}:</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="8" class="contentValue">
        {{ data.Location }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pa-0 align-right">
        <v-list-item dense>
          <v-list-item-icon class="mr-2">
            <v-icon color="neutralGray">mdi-calendar-question</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >{{ $t("agenda.lblMeetingType") }}:</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="8" class="contentValue">
        {{ data.Description }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pa-0 align-right">
        <v-list-item dense>
          <v-list-item-icon class="mr-2">
            <v-icon color="neutralGray">mdi-handshake-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >{{ $t("agenda.lblResType") }}:</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="8" class="contentValue">
        {{ data.resolutionType }}
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Internationalization } from "@syncfusion/ej2-base";

export default {
  name: "QuickInfoContent",
  data() {
    return {
      intl: new Internationalization(),
      data: {},
      labels: ["SU", "MO", "TU", "WED", "TH", "FR", "SA"],
      time: 0,
      forecast: [
        {
          day: "Tuesday",
          icon: "mdi-white-balance-sunny",
          temp: "24\xB0/12\xB0",
        },
        {
          day: "Wednesday",
          icon: "mdi-white-balance-sunny",
          temp: "22\xB0/14\xB0",
        },
        { day: "Thursday", icon: "mdi-cloud", temp: "25\xB0/15\xB0" },
      ],
    };
  },
  computed: {
    headerColor() {
      return this.data.meetingType.color || "#F5CBA7";
    },
  },
  methods: {
    getTimeDetails,
  },
};

function getTimeDetails(data) {
  return (
    this.intl.formatDate(data.StartTime, { type: "date", skeleton: "long" }) +
    " " +
    this.intl.formatDate(data.StartTime, { skeleton: "hm" }) +
    " - " +
    this.intl.formatDate(data.EndTime, { type: "date", skeleton: "long" }) +
    " " +
    this.intl.formatDate(data.EndTime, { skeleton: "hm" })
    // this.intl.formatDate(data.EndTime, { type: "date", skeleton: "long" }) +
    // " (" +
    // this.intl.formatDate(data.StartTime, { skeleton: "hm" }) +
    // " - " +
    // this.intl.formatDate(data.EndTime, { skeleton: "hm" }) +
    // ")"
  );
}
</script>

<style>
.e-quick-popup-wrapper .e-event-popup .e-popup-content {
  padding-bottom: 0px !important;
}
</style>
<style scoped>
::v-deep .contentValue {
  padding-top: 9px;
}
</style>